const templates = (() => {
    return {
        account_info: accountInfoTemplate,
        consolidated_monthly_activity: consolidatedMonthlyActivityTemplate,
        consolidated_monthly_line_item: consolidatedMonthlyLineItemTemplate,
        transactions: transactionsTemplate,
        consolidated_debt_analysis: consolidatedDebtAnalysisTemplate,
        consolidated_trend_analysis: consolidatedTrendAnalysisTemplate,
        ebitda_schedule: ebitdaScheduleTemplate,
        report: reportTemplate,
        bind_events: templateEvents.initEventListeners
    };
})();